/** @jsxImportSource @emotion/react */
import { useState, useEffect } from "react";
import { accessAPI, readFromLS } from "../../shared";

import { Card } from "primereact/card";
import { Skeleton } from "primereact/skeleton";
import { Tooltip } from "primereact/tooltip";

export default function ActividadesAbiertas() {
  const [actividadesEnPaso, setActividadesEnPaso] = useState();
  const [loading, setLoading] = useState(true);
  const [mostrar, setMostrar] = useState(false);

  useEffect(() => {
    let intentos = 0;
    const maxIntentos = 10;
    const intervalo = 300;

    const cargarActividades = () => {
      const token = readFromLS(process.env.REACT_APP_LS_LOGIN_TOKEN);

      if (!token) {
        if (intentos < maxIntentos) {
          intentos++;
          setTimeout(cargarActividades, intervalo);
        } else {
          setLoading(false);
        }
        return;
      }

      accessAPI(
        "GET",
        "colab/actividad",
        null,
        (respuesta) => {
          if (respuesta.pasosActualesDecisor?.length > 0) {
            setActividadesEnPaso(respuesta.pasosActualesDecisor);
            setMostrar(true);
          }
          setLoading(false);
        },
        (respuesta) => {
          // No mostrar nada si hay error (401, 403, etc.)
          setLoading(false);
        },
      );
    };

    cargarActividades();
  }, []);

  // No renderizar nada si no hay datos para mostrar
  if (!mostrar && !loading) {
    return null;
  }

  // No renderizar nada mientras carga si no sabemos si hay datos
  if (loading) {
    return (
      <>
        <Skeleton
          width="22em"
          height="2.1em"
          css={{ marginBottom: "1.1em", marginTop: "1em" }}
        />
        <div className="grid">
          {[1, 2, 3].map((i) => (
            <div className="col-12 md:col-6 lg:col-4" key={i}>
              <Card css={{ textAlign: "center", minHeight: "125px" }}>
                <Skeleton
                  width="80%"
                  height="1.5em"
                  css={{ margin: "0 auto 1.5em auto" }}
                />
                <Skeleton width="60%" height="1em" css={{ margin: "0 auto" }} />
              </Card>
            </div>
          ))}
        </div>
      </>
    );
  }

  // Agrupar actividades por cliente
  const actividadesPorCliente = {};
  actividadesEnPaso?.forEach((paso) => {
    const cliente = paso.actividad.proceso.cliente;
    const key = cliente.razonsocial;
    if (!actividadesPorCliente[key]) {
      actividadesPorCliente[key] = [];
    }
    actividadesPorCliente[key].push(paso);
  });

  // Ordenar clientes alfabéticamente y actividades por nombre de proceso dentro de cada cliente
  const clientesOrdenados = Object.entries(actividadesPorCliente)
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([nombre, pasos]) => [
      nombre,
      pasos.sort((a, b) =>
        a.actividad.proceso.nombre.localeCompare(b.actividad.proceso.nombre)
      )
    ]);

  return (
    <>
      <h2>Actividades abiertas</h2>
      {clientesOrdenados.map(([clienteNombre, pasos]) => (
        <div key={clienteNombre} css={{ marginBottom: "1.5em" }}>
          <h3 css={{ marginBottom: "0.5em" }}>{clienteNombre}</h3>
          <div className="grid">
            {pasos.map((paso) => (
              <div className="col-12 md:col-6 lg:col-4" key={paso.id}>
                <Card
                  css={{ textAlign: "center", cursor: "pointer", position: "relative" }}
                  onClick={(event) =>
                    window.open(
                      `/actividad/${paso.id}`,
                      event.metaKey || event.ctrlKey ? "_blank" : "_self",
                    )
                  }
                >
                  {paso.comentarioStatus && (
                    <>
                      <Tooltip target={`.status-icon-${paso.id}`} position="top" />
                      <i
                        className={`pi pi-info-circle status-icon-${paso.id}`}
                        data-pr-tooltip={paso.comentarioStatus}
                        css={{
                          position: "absolute",
                          top: "0.75rem",
                          right: "0.75rem",
                          color: "var(--amarillo)",
                          fontSize: "1.2rem",
                        }}
                      />
                    </>
                  )}
                  <div>
                    <strong>{`${paso.actividad.proceso.nombre} - ${paso.actividad.proceso.nombrefantasia}`}</strong>
                    <p>
                      {`${paso.actividad.actividadtipo.nombre} - ${paso.nombre}`}
                    </p>
                    {paso.actividad._count?.hallazgos > 0 && (
                      <span
                        css={{
                          display: "inline-block",
                          marginTop: "0.25rem",
                          marginRight: "0.4rem",
                          padding: "0.2rem 0.6rem",
                          borderRadius: "4px",
                          backgroundColor: "var(--rojo)",
                          color: "white",
                          fontSize: "0.8rem",
                          fontWeight: 600,
                        }}
                      >
                        {paso.actividad._count.hallazgos} hallazgo{paso.actividad._count.hallazgos > 1 ? "s" : ""} abierto{paso.actividad._count.hallazgos > 1 ? "s" : ""}
                      </span>
                    )}
                    {paso.enFormacion && (
                      <span
                        css={{
                          display: "inline-block",
                          marginTop: "0.25rem",
                          padding: "0.2rem 0.6rem",
                          borderRadius: "4px",
                          backgroundColor: "var(--principal)",
                          color: "white",
                          fontSize: "0.8rem",
                          fontWeight: 600,
                        }}
                      >
                        <i className="pi pi-graduation-cap" css={{ marginRight: "0.3rem", fontSize: "0.8rem" }} />
                        En formación
                      </span>
                    )}
                  </div>
                </Card>
              </div>
            ))}
          </div>
        </div>
      ))}
    </>
  );
}
